import axios from 'axios';
import * as qs from 'query-string';
import { APP_NAME } from 'login-constants/globals';

export const axiosDefaults = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'client-name': APP_NAME,
  },
  paramsSerializer: /* istanbul ignore next */ (params: any) => qs.stringify(params),
};

const axiosInstance = axios.create(axiosDefaults);

export default axiosInstance;
